import { BASE_URL } from "@utils/constants";
import {
  addAssignedProjects,
  addSentences,
  addAssignedFolders,
  addAssignedFiles,
  setSelectedAssignedProjectId,
  setSelectedAssignedFolderId,
  setSelectedAssignedFileId,
  setSelectedFile,
  addRejectedSentences,
} from "@store/slices/gaAdminSlice";

import { setFileMeta } from "@store/slices/fileMetaSlice";
import apiClient from "@/services/api/apiClient";
// Fetch projects for validator admin
export const fetchGAAdminProjects = (keyword = '', page = 0, size = 10) => async (dispatch, getState) => {
  try {
    const state = getState();
    const { userId,token } = state.auth;
    const data = await apiClient(
      BASE_URL + `api/gsAdmin/projects?gsUserId=${userId}&searchKeyword=${keyword}&page=${page}&size=${size}`,
      {
        method: "GET",
        credentials: "include",
        headers: {
          "Content-Type": "application/json",
          "Authorization": `Bearer ${token}`
        }
      }
    );
    console.log("Fetched GA admin projects:", data.data);
    dispatch(addAssignedProjects(data.data));
    if (data.data?.length) {
      console.log(data.data[0].projectId)
      dispatch(setSelectedAssignedProjectId(data.data[0].projectId));
    }
    return data.data;
  } catch (error) {
    console.error("Error fetching validator admin projects:", error);
  }
};


export const fetchGAAdminFolders = (projectId, keyword = '', page = 0, size = 10) => async (dispatch, getState) => {
  const state = getState();
  const { userId, token } = state.auth;
  try {
    console.log(`Fetching folders for GA Admin: ${userId}, project: ${projectId}`);
    const data = await apiClient(
      BASE_URL + `api/gsAdmin/folders?projectId=${projectId}&searchKeyword=${keyword}&page=${page}&size=${size}`,
      {
        credentials: "include",
        headers: {
          "Content-Type": "application/json",
          "Authorization": `Bearer ${token}`
        }
      }
    );
    console.log("GA Admin folders:", data.data);

    dispatch(addAssignedFolders(data.data));

    return data.data;
  } catch (error) {
    console.error("Error fetching GA folders:", error);
    return [];
  }
}


// Fetch files for a specific folder assigned to validator
export const fetchGAAdminFiles = (folderId, keyword = '', page = 0, size = 10) => async (dispatch, getState) => {
  const state = getState();
  const { userId, token } = state.auth;
  try {
    console.log(`Fetching files for GA Admin: ${userId}, folder: ${folderId}`);
    const data = await apiClient(
      BASE_URL + `api/gsAdmin/files?folderId=${folderId}&searchKeyword=${keyword}&page=${page}&size=${size}`,
      {
        credentials: "include",
        headers: {
          "Content-Type": "application/json",
          "Authorization": `Bearer ${token}`
        }
      }
    );
    console.log("GAA files:", data.data);

    dispatch(addAssignedFiles(data.data));
    return data.data;
  } catch (error) {
    console.error("Error fetching GAA files:", error);
    return [];
  }
};


// Fetch sentences for validation from a specific file
export const fetchSentencesForGAAdmin = (fileId, fileStatus, validationFileStatus, targetLanguageId) => async (dispatch, getState) => {
  try {
    const state = getState();
    const { userId, token } = state.auth;
    console.log(`fetchSentencesForGAAdmin called with fileId: ${fileId}, fileStatus: ${fileStatus}, validationFileStatus: ${validationFileStatus}, targetLanguageId: ${targetLanguageId}`);
    console.log(`Fetching sentences for GA Admin, file: ${fileId} ${fileStatus} ${validationFileStatus} ${targetLanguageId}`);
    const url = fileStatus === "SENT_TO_VA" && (validationFileStatus === 'COMPLETED' || validationFileStatus === 'SUBMITTED' || validationFileStatus === 'SUBMITTED_TO_CDAC') ? `api/gsAdmin/sentences?fileId=${fileId}&sourceId=2&targetId=${targetLanguageId}` : `api/gsAdmin/approvedSentences?fileId=${fileId}`;
    const data = await apiClient(
      BASE_URL + url,
      {
        credentials: "include",
        headers: {
          "Content-Type": "application/json",
          "Authorization": `Bearer ${token}`
        }
      }
    );

    dispatch(addSentences(data.data));

    return data;
  } catch (error) {
    console.error("Error fetching sentences for GA Admin:", error);
    return [];
  }
};


export const fetchSelectedFileDataForGAAdmin = (fileId) => async (dispatch, getState) => {
  try {
    const state = getState();
    const { userId, token } = state.auth;

    if (!fileId) {
      console.error("fileId is required for fetching translator admins");
      return [];
    }

    console.log(`Fetching translator admins for GA Admin, file: ${fileId}`);
    const data = await apiClient(
      BASE_URL + `api/gsAdmin/TAwithLanguages`,
      {
        credentials: "include",
        headers: {
          "Content-Type": "application/json",
          "Authorization": `Bearer ${token}`
        }
      }
    );
    console.log("translator admins for GA Admin:", data.data);

    // Ensure we're setting an array
    const adminData = Array.isArray(data.data) ? data.data : [];
    dispatch(setSelectedFile(adminData));

    return adminData;
  } catch (error) {
    console.error("Error fetching translator admins for GA Admin:", error);
    // Set empty array on error to prevent undefined issues
    dispatch(setSelectedFile([]));
    return [];
  }
};



export const assignToOneTranslatorAdmin = (fileId, transId, targetLanguageId) => async (dispatch, getState) => {
  try {
    const state = getState();
    const { userId, token } = state.auth;
    console.log(`Assigning file ${fileId} to translator admin ${transId} for language ${targetLanguageId}`);
    const data = await apiClient(
      BASE_URL + `api/gsAdmin/file/assignTA?fileId=${fileId}&translatorAdminId=${transId}&targetLanguageId=${targetLanguageId}`,
      {
        method: 'POST',
        credentials: "include",
        headers: {
          "Content-Type": "application/json",
          "Authorization": `Bearer ${token}`
        }
      }
    );


    const fileName = Object.values(state.gaAdmin.assignedFiles)
      .flat()
      .find(file => file.fileId === fileId)?.fileName;

    console.log("Assigned to admin", data.data);
    // dispatch(fetchSelectedFileDataForGAAdmin(fileId))
    dispatch(setFileMeta({ fileId: fileId, fileName: fileName }));
    // dispatch(setSelectedFile(data.data));

    return data.data;
  } catch (error) {
    console.error("Error assigning to admin", error);
    return [];
  }
};



export const assignToAlllTranslatorAdmins = (fileId) => async (dispatch, getState) => {
  try {
    const state = getState();
    const { userId, token } = state.auth;
    console.log(`Assigning file ${fileId} to translator admins`);
    const data = await apiClient(
      BASE_URL + `api/gsAdmin/file/assignAllTA?fileId=${fileId}`,
      {
        method: 'POST',
        credentials: "include",
        headers: {
          "Content-Type": "application/json",
          "Authorization": `Bearer ${token}`
        }
      }
    );
    console.log("Assigned to admins", data.data);

    // dispatch(setSelectedFile(data.data));

    return data;
  } catch (error) {
    console.error("Error assigning to admin", error);
    return [];
  }
};

// Activate a GA Admin user
export const activateGAAdminUser = (userId) => async (dispatch, getState) => {
  try {
    const state = getState();
    const { token } = state.auth;
    const data = await apiClient(
      BASE_URL + `api/gsAdmin/activate?gsUserId=${userId}`,
      {
        method: 'PUT',
        credentials: "include",
        headers: {
          "Content-Type": "application/json",
          "Authorization": `Bearer ${token}`
        }
      }
    );
    return data;
  } catch (error) {
    console.error('Error activating GA Admin user:', error);
    return { success: false, message: 'Error activating user' };
  }
};

// Suspend a GA Admin user (with query param)
export const suspendGAAdminUser = (userId) => async (dispatch, getState) => {
  try {
    const state = getState();
    const { token } = state.auth;
    const data = await apiClient(
      BASE_URL + `api/gsAdmin/suspend?gsUserId=${userId}`,
      {
        method: 'PUT',
        credentials: "include",
        headers: {
          "Content-Type": "application/json",
          "Authorization": `Bearer ${token}`
        }
      }
    );
    return data;
  } catch (error) {
    console.error('Error suspending GA Admin user:', error);
    return { success: false, message: 'Error suspending user' };
  }
};

// Fetch all active GA Admin users
export const fetchActiveGAAdminUsers = () => async (dispatch, getState) => {
  try {
    const state = getState();
    const { token } = state.auth;

    const data = await apiClient(
      BASE_URL + 'api/gsAdmin/active',
      {
        method: 'GET',
        credentials: "include",
        headers: {
          "Content-Type": "application/json",
          "Authorization": `Bearer ${token}`
        }
      }
    );
    return Array.isArray(data.data) ? data.data : [];
  } catch (error) {
    console.error('Error fetching active GA Admin users:', error);
    return [];
  }
};

// Fetch all pending GA Admin users
export const fetchPendingGAAdminUsers = () => async (dispatch, getState) => {
  try {
    const state = getState();
    const { token } = state.auth;
    const data = await apiClient(
      BASE_URL + 'api/gsAdmin/pending',
      {
        method: 'GET',
        credentials: "include",
        headers: {
          "Content-Type": "application/json",
          "Authorization": `Bearer ${token}`
        }
      }
    );
    return Array.isArray(data.data) ? data.data : [];
  } catch (error) {
    console.error('Error fetching pending GA Admin users:', error);
    return [];
  }
};

// Fetch all suspended GA Admin users
export const fetchSuspendedGAAdminUsers = () => async (dispatch, getState) => {
  try {
    const state = getState();
    const { token } = state.auth;
    const data = await apiClient(
      BASE_URL + 'api/gsAdmin/suspended',
      {
        method: 'GET',
        credentials: "include",
        headers: {
          "Content-Type": "application/json",
          "Authorization": `Bearer ${token}`
        }
      }
    );
    return Array.isArray(data.data) ? data.data : [];
  } catch (error) {
    console.error('Error fetching suspended GA Admin users:', error);
    return [];
  }
};

// Fetch rejected sentences for a specific file
export const fetchRejectedSentencesForGAAdmin = (fileId) => async (dispatch, getState) => {
  try {

    console.log(`Fetching rejected sentences for GA Admin, file: ${fileId}`);
    const data = await apiClient(
      BASE_URL + `api/gsAdmin/rejectedSentences?fileId=${fileId}`,
      {
        credentials: "include",
        headers: {
          "Authorization": `Bearer ${token}`,
          "Content-Type": "application/json",
        }
      }
    );

    if (data.status === "success" && Array.isArray(data.data)) {
      dispatch(addRejectedSentences(data.data));
    }

    return data.data || [];
  } catch (error) {
    console.error("Error fetching rejected sentences for GA Admin:", error);
    return [];
  }
};


